'use client'

import { UploadImageModal } from '@/app/minha-area/_components/UploadImageModal'

interface HistoryPhotoEditButtonProps {
	id: string
	isEditable: boolean
	setImageUrl: (imageUrl: string) => void
}

export function HistoryPhotoEditButton({ setImageUrl, id, isEditable }: HistoryPhotoEditButtonProps) {
	if (!isEditable) return null

	return (
		<UploadImageModal id={id} setImageUrl={setImageUrl} isEditable={isEditable} mode="history">
			<div className="absolute top-28 right-48 transition-opacity z-10">
				<img src="/edit-pen.png" alt="Editar capa" className="w-16" />
			</div>
		</UploadImageModal>
	)
}
